import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Resolves /t/{code} and /p/{code} short links to the full event page.
export default function SportsShortLinkPage({ kind, live = false, subdomainOverride = null }) {
  const { slug: slugParam, code } = useParams();
  const navigate = useNavigate();
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const ref = slugParam || subdomainOverride;
    if (!ref || !code) { setNotFound(true); return; }
    axios.get(`${BACKEND}/api/sports/short/${ref}/${kind}/${code}`)
      .then(r => {
        const { slug, id, status, event_style } = r.data;
        if (kind === 't') {
          // Announce events have no live bracket — the tournament page IS the destination
          const wantSpectator = live && event_style !== 'announce';
          navigate(wantSpectator ? `/book/${slug}/tournament/${id}/spectator` : `/book/${slug}/tournament/${id}`, { replace: true });
        } else {
          navigate(live || status === 'active' ? `/book/${slug}/open-play/${id}` : `/book/${slug}/open-play/${id}/register`, { replace: true });
        }
      })
      .catch(() => setNotFound(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="short-link-page" style={{ minHeight: '100vh', background: '#0A0A0A', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {notFound ? (
        <div style={{ textAlign: 'center' }}>
          <p data-testid="short-link-not-found" style={{ color: '#E63946', fontFamily: 'Oswald, sans-serif', fontSize: 20, textTransform: 'uppercase' }}>Event not found</p>
          <p style={{ color: '#777', fontSize: 13, marginTop: 8 }}>This link may have expired or been removed.</p>
        </div>
      ) : (
        <p style={{ color: '#777', fontSize: 14 }}>Loading event…</p>
      )}
    </div>
  );
}
